// extracted by mini-css-extract-plugin
export default {"movieCard":"MovieCard_movieCard__779Nd","titles":"MovieCard_titles__E6Wwo","movieImage":"MovieCard_movieImage__ViSwS"};